import {
  collection,
  getDocs,
  onSnapshot,
  orderBy,
  query,
  updateDoc,
  doc,
  limit
} from 'firebase/firestore';
import { db, functions, httpsCallable } from '../firebase';

const SEND_PREINVOICES_FN = httpsCallable(functions, 'sendPreinvoices');

export const PREINVOICE_STATUSES = ['Sent', 'pending payment', 'Payed', 'sendError'];

export const PREINVOICE_EMAIL_FROM_NAME = 'TenisoUžsiėmimai.lt';

// Placeholders are replaced per-recipient on the server side.
// Keep in sync with PREINVOICE_DEFAULT_MESSAGE_TEMPLATE in functions/index.js.
export const PREINVOICE_DEFAULT_MESSAGE_TEMPLATE = `Laba diena, {{vardas}},

Siunčiame išankstinės sąskaitą faktūrą už planuojamas suteikti paslaugas. PDF failas laiško prisegtuke. Taip sąskaitą galite peržiūrėti paspaudę nuorodos mygtuką apačioje.

Suma: {{suma}}
Sąskaitos numeris: {{saskaitosNumeris}}

{{pdfUrl}}

Linkime malonaus laiko aikštelėje!
${PREINVOICE_EMAIL_FROM_NAME}`;

export const PREINVOICE_TEMPLATE_PLACEHOLDERS = [
  { key: '{{vardas}}', description: 'kliento vardas' },
  { key: '{{pdfUrl}}', description: 'PDF nuoroda (HTML laiške rodoma kaip mygtukas „Atsisiųsti sąskaitą (PDF)")' },
  { key: '{{suma}}', description: 'suma (pvz. „40.00 Eur“)' },
  { key: '{{saskaitosNumeris}}', description: 'sąskaitos numeris' },
  { key: '{{data}}', description: 'metai-mėnuo (pvz. „2026-05“)' }
];

/** Client-side preview of a template for one recipient. Mirrors server substitution. */
export const previewPreinvoiceMessage = (template, vars) => {
  return String(template || '').replace(/\{\{(\w+)\}\}/g, (m, key) => {
    if (vars && Object.prototype.hasOwnProperty.call(vars, key) && vars[key] != null) {
      return String(vars[key]);
    }
    return m;
  });
};

export const getPreinvoiceRecipients = async () => {
  const snapshot = await getDocs(collection(db, 'userProfiles'));
  const rows = snapshot.docs
    .map((d) => ({ id: d.id, ...d.data() }))
    .filter((u) => !u.blocked && u.email && String(u.email).includes('@'))
    .map((u) => ({
      id: u.id,
      userId: u.userId || '',
      fullName: u.fullName || '',
      email: String(u.email || '').trim().toLowerCase(),
      phoneNumber: String(u.phoneNumber || u.phone || '').trim(),
      createdAt: u.createdAt || null,
      updatedAt: u.updatedAt || null
    }));

  rows.sort((a, b) => {
    const ta = a.createdAt?.toMillis?.() ?? a.updatedAt?.toMillis?.() ?? 0;
    const tb = b.createdAt?.toMillis?.() ?? b.updatedAt?.toMillis?.() ?? 0;
    return tb - ta; // newest first
  });
  return rows;
};

export const sendPreinvoices = async ({ amountEur, recipients, isTest, messageTemplate }) => {
  const response = await SEND_PREINVOICES_FN({
    amountEur,
    recipients,
    isTest: isTest === true,
    messageTemplate: typeof messageTemplate === 'string' ? messageTemplate : ''
  });
  return response?.data || { ok: false, results: [] };
};

export const subscribeToRecentPreinvoices = (year, callback) => {
  const yearRef = collection(db, 'preinvoices', String(year), 'items');
  const q = query(yearRef, orderBy('createdAt', 'desc'), limit(100));
  return onSnapshot(q, (snap) => {
    const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
    callback(list);
  }, (error) => {
    console.error('preinvoices snapshot error:', error);
    callback([]);
  });
};

export const updatePreinvoiceStatus = async (year, docId, status) => {
  if (!PREINVOICE_STATUSES.includes(status)) {
    throw new Error('Neteisingas statusas');
  }
  const ref = doc(db, 'preinvoices', String(year), 'items', docId);
  await updateDoc(ref, { status });
};
